import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { pageUrl } from '@/constants/url'

const DealsPage = lazy(() => import('./pages/dealsPage'))
const RatingPage = lazy(() => import('./pages/ratingPage'))

export const engagementsPrivateRoutes = () => {
  return (
    <>
      <Route path={pageUrl.deals} element={<DealsPage />} />
    </>
  )
}

export const engagementsPublicRoutes = () => {
  return (
    <>
      <Route path={pageUrl.rating} element={<RatingPage />} />
    </>
  )
}
